import { createAsyncThunk } from '@reduxjs/toolkit'
import { H_PRODUCTION_MODULE } from 'account/constants/AccessRulesConstants'
import ApplicationConf from 'conf/ApplicationConf'
import LogAction from 'log/actions/LogAction'
import i18n from 'simple-react-i18n'
import { REJECTED, IDLE } from 'store/DataManagerConstants'
import ToastrAction from 'toastr/actions/ToastrAction'
import { genericPromise } from 'utils/ActionUtils'
import { isAuthorized } from 'utils/HabilitationUtil'

const ProductionUnitThunk = {
    fetchProductionUnits: createAsyncThunk(
        'fetchProductionUnits',
        async (_, { rejectWithValue, dispatch }) => {
            try {
                const response = await genericPromise(ApplicationConf.productionUnit.getAll(), 'GET')
                return response
            } catch (err) {
                dispatch(LogAction.logError(`${i18n.fetchError} ${i18n.productionUnit} : ${err}`))
                dispatch(ToastrAction.error(`${i18n.fetchError} ${i18n.productionUnit}`))
                return rejectWithValue(err)
            }
        },
        {
            condition: (arg = { forceFetch: false }, { getState }) => {
                const state = getState()
                if (!isAuthorized(H_PRODUCTION_MODULE, state)) {
                    return false
                }
                const { productionUnitsStatus } = state.DataManagerReducer.productionUnit
                if (arg.forceFetch) {
                    return productionUnitsStatus !== REJECTED
                }
                return productionUnitsStatus === IDLE
            },
            dispatchConditionRejection: true,
        },
    ),
}

export default ProductionUnitThunk